export const WHATSAPP_NUMBER = "966507336999";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PUBLIC_PHONE_LINK = `tel:+${WHATSAPP_NUMBER}`;
